<fieldset>
  <div class="search-container">
    <input
      #quickSearchInput
      #typeaheadInstance="ngbTypeahead"
      type="text"
      placeholder="Snabbsök..."
      [(ngModel)]="searchString"
      [ngbTypeahead]="searchHandler"
      [resultTemplate]="rt"
      (selectItem)="itemSelected($event)"
      [inputFormatter]="inputFormatter"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />
      <div class="icon-wrapper">
        @if (searchComplete$ | async) {
          <i class="fas fa-lg fa-search search" aria-hidden="true"></i>
        } @else {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
      </div>
      <ng-template #rt let-r="result" let-t="term">
        <ng-template raskRendererResolver [type]="r.type" [input]="r" [searchExtended]="searchExtended" [tooltipTemplate]="template"></ng-template>
        <ng-template #template>
          {{ getTooltipText(r) }}
          <ng-content></ng-content>
        </ng-template>
        <div #templateResult style="display: none">
          <ng-container *ngTemplateOutlet="template"></ng-container>
        </div>
      </ng-template>
    </div>
  </fieldset>
